



























import { defineComponent } from '@vue/composition-api';
import ArrowsVIcon from '@front-app/components/icons-old/ArrowsV.vue';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default defineComponent({
	components: {
		ArrowsVIcon,
		IconButton,
		FontAwesomeIcon,
	},
	props: {
		// Enables a semi-transparent hover effect, enabling stacking of multiple wrappers
		hasTranslucentHover: Boolean,
		// Highlights a selected item
		isSelected: Boolean,
	},
	setup() {
		return {};
	},
});
